module.exports = __webpack_public_path__ + "img/blog3.42bc68b1.png";